import React, { useState } from 'react';
import { VStack, Text, Input, Button, FormControl, FormLabel, InputGroup, InputRightElement, RadioGroup, HStack, Radio, FormErrorMessage } from '@chakra-ui/react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import LogoSection from './login-register/LogoSection';

const UserInfoCardContent = ({
  name,
  onNameChange,
  gender,
  onGenderChange,
  password,
  onPasswordChange,
  confirmPassword,
  onConfirmPasswordChange,
  passwordError,
  onSignUp
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <VStack spacing={4} align="stretch">
      <LogoSection />
      <Text fontSize="2xl" fontWeight="bold" color="gray.800" textAlign="center">
        User Information
      </Text>
      <FormControl>
        <FormLabel>Your Name</FormLabel>
        <Input placeholder="Enter Your Full Name" value={name} onChange={onNameChange} />
      </FormControl>
      <FormControl>
        <FormLabel>Gender</FormLabel>
        <RadioGroup value={gender} onChange={onGenderChange}>
          <HStack spacing={6}>
            <Radio value="male">Male</Radio>
            <Radio value="female">Female</Radio>
            <Radio value="other">Other</Radio>
          </HStack>
        </RadioGroup>
      </FormControl>
      <FormControl isInvalid={!!passwordError}>
        <FormLabel>Password</FormLabel>
        <InputGroup>
          <Input
            type={showPassword ? 'text' : 'password'}
            placeholder="Enter Your Password"
            value={password}
            onChange={onPasswordChange}
          />
          <InputRightElement>
            <Button variant="ghost" size="sm" onClick={() => setShowPassword(s => !s)}>
              {showPassword ? <ViewOffIcon /> : <ViewIcon />}
            </Button>
          </InputRightElement>
        </InputGroup>
      </FormControl>
      <FormControl isInvalid={!!passwordError}>
        <FormLabel>Confirm Password</FormLabel>
        <InputGroup>
          <Input
            type={showConfirmPassword ? 'text' : 'password'}
            placeholder="Enter Your Confirm Password"
            value={confirmPassword}
            onChange={onConfirmPasswordChange}
          />
          <InputRightElement>
            <Button variant="ghost" size="sm" onClick={() => setShowConfirmPassword(s => !s)}>
              {showConfirmPassword ? <ViewOffIcon /> : <ViewIcon />}
            </Button>
          </InputRightElement>
        </InputGroup>
        <FormErrorMessage>
          {passwordError}
        </FormErrorMessage>
      </FormControl>
      <Text color="red.500" fontSize="xs" mt={1} textAlign="center">
        [*Minimum 6 characters at least 1 Alphabet, 1 Number and 1 Special Character]
      </Text>
      <Button colorScheme="blue" size="lg" w="full" onClick={onSignUp}>
        Sign Up
      </Button>
    
    </VStack>
  );
};

export default UserInfoCardContent; 